import React from 'react';
import { Instagram, FileText, MessageCircle, Phone, Music, HelpCircle, Package } from 'lucide-react';
import { Link } from 'react-router-dom';

const Home = () => {
  const links = [
    {
      title: 'Register For Your Consultation | سجل لإستشارتك الأولى',
      url: 'https://forms.gle/opDVc3ZdYm9tpTUg6',
      icon: <FileText className="w-6 h-6" />,
    },
    {
      title: 'Instagram',
      url: 'https://www.instagram.com/crosslink.kw/',
      icon: <Instagram className="w-6 h-6" />,
    },
    {
      title: 'TikTok',
      url: 'https://www.tiktok.com/@crosslink.kw?_t=ZT-8z3w26JjjeX&_r=1',
      icon: <Music className="w-6 h-6" />,
    },
    {
      title: 'WhatsApp',
      url: 'https://wa.me/96598551104',
      icon: (
        <div className="relative w-6 h-6">
          <MessageCircle className="w-6 h-6" />
          <Phone className="w-3 h-3 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
        </div>
      ),
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white py-12 px-4">
      <div className="max-w-xl mx-auto">
        <div className="flex flex-col items-center justify-center mb-10">
          <div className="w-64 h-60 mb-5 relative">
            <img
              src="/GoDaddyStudioPage-0.jpeg"
              alt="CrossLink Logo"
              className="w-full h-full rounded-full border-4 border-white object-cover absolute transform hover:scale-110 transition-transform duration-300"
            />
          </div>
          <h1 className="text-4xl font-bold mb-2">CrossLink</h1>
          <p className="text-gray-400 text-lg">MAKING PEOPLE'S LIFE EASIER</p>
        </div>

        <div className="space-y-2 mb-6">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full py-3 px-4 bg-gray-900 rounded-xl transition-all duration-300 transform hover:scale-[1.02] hover:bg-green-900 hover:text-white"
            >
              <div className="flex items-center justify-center text-center">
                <div className="flex flex-col items-center space-y-2 sm:flex-row sm:space-y-0 sm:space-x-3">
                  {link.icon}
                  <span className="font-medium text-center">{link.title}</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Packages Section */}
        <div className="mb-6">
          <Link
            to="/packages"
            className="block w-full py-3 px-4 bg-gradient-to-r from-blue-800 to-blue-700 rounded-xl transition-all duration-300 transform hover:scale-[1.02] hover:from-blue-700 hover:to-blue-600"
          >
            <div className="flex items-center justify-center text-center">
              <div className="flex flex-col items-center space-y-2 sm:flex-row sm:space-y-0 sm:space-x-3">
                <Package className="w-6 h-6" />
                <span className="font-medium text-center">View All Packages | عرض جميع الباقات</span>
              </div>
            </div>
          </Link>
        </div>

        {/* FAQ Link */}
        <div className="mb-10">
          <Link
            to="/faq"
            className="block w-full py-3 px-4 bg-gradient-to-r from-green-800 to-green-700 rounded-xl transition-all duration-300 transform hover:scale-[1.02] hover:from-green-700 hover:to-green-600"
          >
            <div className="flex items-center justify-center text-center">
              <div className="flex flex-col items-center space-y-2 sm:flex-row sm:space-y-0 sm:space-x-3">
                <HelpCircle className="w-6 h-6" />
                <span className="font-medium text-center">Frequently Asked Questions</span>
              </div>
            </div>
          </Link>
        </div>

        <footer className="text-center text-gray-400">
          <p>© {new Date().getFullYear()} CrossLink. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default Home;